import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AttachFileIcon(props: IconProps) {
    return <Icon {...props} iconKey={"attach_file"}/>
}
